document.addEventListener('DOMContentLoaded', function () {
    const carousel = document.querySelector('.carousel');
    const leftArrow = document.querySelector('.left-arrow');
    const rightArrow = document.querySelector('.right-arrow');
    let scrollAmount = 0;

    const maxScroll = carousel.scrollWidth - carousel.clientWidth;

    rightArrow.addEventListener('click', function () {
        if (scrollAmount < maxScroll) {
            scrollAmount += carousel.clientWidth;
            carousel.style.transform = `translateX(-${scrollAmount}px)`;
        }
    });

    leftArrow.addEventListener('click', function () {
        if (scrollAmount > 0) {
            scrollAmount -= carousel.clientWidth;
            carousel.style.transform = `translateX(-${scrollAmount}px)`;
        }
    });
});
